'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedHubs = {
  HUBS_CAMPAIGN: 'HUBS_CAMPAIGN',
  HUBS_CONTENT: 'HUBS_CONTENT',
  HUBS_CTA: 'HUBS_CTA',
  HUBS_MEDIUM: 'HUBS_MEDIUM'
};

exports.default = AllowedHubs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.35/js/constants/AllowedHubs.js
// module id = 303
// module chunks = 2 3